import { HttpContext } from '@angular/common/http';

import {
  EnvironmentService,
  REQUEST_TIMEOUT,
  RESPONSE_CACHE_TTL,
  TRANSFER_STATE_URL_REPLACER
} from '@hdms/shared/util-core';

// 2 hr cache ttl
const TTL = 7200;

// 5 secs request timeout
const TIMEOUT = 5000;

export const AEM_CONTENT_PATH = '/content/hilti';

export function getAemEndpointUrl(
  endpoint: string,
  { aemEndpointUrl, hub, country, language }: EnvironmentService
): string {
  return `${aemEndpointUrl}${AEM_CONTENT_PATH}/${hub}/${country}/${language}.${endpoint}`;
}

export function getAemRequestOptions({ aemEndpointUrl }: EnvironmentService): { context?: HttpContext } {
  return {
    context: new HttpContext()
      .set(RESPONSE_CACHE_TTL, TTL)
      .set(REQUEST_TIMEOUT, TIMEOUT)
      .set(TRANSFER_STATE_URL_REPLACER, url => url.replace(aemEndpointUrl, ''))
  };
}
